import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { useTranslation } from 'react-i18next';

import useOrderPrepaidCard
    from './hooks/useOrderPrepaidCard';

interface Props {
    prepaidCardImageId: string;
}

function PurchaseButton({ prepaidCardImageId }:Props) {
    const { t } = useTranslation('prepaidCard');
    const { handlePurchase, amount, orderDisabled } = useOrderPrepaidCard(prepaidCardImageId);
    return (
        <Column
            fullWidth
            spacing={16} >
            <Row fullWidth justify='space-between'>
                <Text size='xl' fontWeight='bold'>{t('image.paymentAmount')}</Text>
                <Text size='3xl' fontWeight='bold' color={colors.red}>
                    {amount.toLocaleString()}{t('currencyUnit')}
                </Text>
            </Row>
            <Button fullWidth onClick={handlePurchase}
                disabled={orderDisabled} >
                {t('image.payment')}
            </Button>
        </Column>
    );
}

export default PurchaseButton;
